import {Center, Flex, Stack} from '@chakra-ui/react';
import {GeoErrorIcon} from 'components/icons/GeoIcon';
import {GeoHeaderText} from 'components/text/GeoHeaderText';
import {GeoSubtitleText} from 'components/text/GeoSubtitleText';
import {useTranslation} from 'modules/i18n';
import React from 'react';

export interface ErrorCardProps {
	isMobile?: boolean;
	content?: React.ReactNode;
	title?: string;
}

export const ErrorCard: React.FC<ErrorCardProps> = ({
	isMobile,
	content,
	title
}: ErrorCardProps) => {
	const {t} = useTranslation();
	return (
		<>
			<Flex
				height={isMobile ? 'max-content' : '100%'}
				width={isMobile ? '100%' : '100%'}
				minHeight={isMobile ? '137px' : '113px'}
				borderRadius='lg'
				boxShadow='md'
				data-cy='errorCard'
			>
				<Flex
					bg='geoRed.500'
					minHeight='100%'
					width='.7rem'
					minWidth={isMobile ? '6px' : '2px'}
					borderTopLeftRadius='lg'
					borderBottomLeftRadius='lg'
				/>
				<Flex minHeight='100%' pl={5} py={3} width='100%'>
					<Flex height='100%' alignItems='center' width='15%'>
						<Center>
							<GeoErrorIcon />
						</Center>
					</Flex>
					<Flex height='100%' alignItems='center' width='70%' marginLeft='20px'>
						<Stack mt={2} width='100%' direction='column' spacing={2}>
							<Flex>
								<GeoHeaderText fontSize='md'>
									{title ? title : t('errors.default')}
								</GeoHeaderText>
							</Flex>
							<Flex>
								<GeoSubtitleText fontSize='md'>{content}</GeoSubtitleText>
							</Flex>
						</Stack>
					</Flex>
				</Flex>
			</Flex>
		</>
	);
};
